module.exports = __webpack_public_path__ + "static/media/search-think-icon.c078c8be.svg";